import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  content: {
    position: 'relative',
  },
  loader: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%) scale(2)',
    transformOrigin: 'center center',
  },
  medias: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 16,
  },
  mediaIcon: {
    margin: '0 10px',
  },
});
